module.exports = __webpack_public_path__ + "img/img_ia_pen_gpdf.8d958b14.png";